import {h} from 'preact';

const GroupLabel = ( {children, ...props} ) =>
    <div {...props}
         className="block px-4 py-2 bg-white font-bold txt-c3 border-b border-solid border-grey-lighter">
        {children}
    </div>;

export default GroupLabel;
